module.exports = __webpack_public_path__ + "img/ic_32_back-to-top.adeb6354.svg";